import types from "@/store/types/Ampliacion";
import Vue from "vue";

const state = {
  datosAmpliaciones: {},
  datosAmpliacionesNet: [],
  tipoSolicitudLis: [],
  tipoSolicitud: null
};
const getters = {
  [types.getters.GetAmpliacion]: state => {
    let obj = state.datosAmpliaciones;
    return obj;
  },
  [types.getters.GettipoSolicitudLis]: state => {
    return state.tipoSolicitudLis;
  },
  [types.getters.GetdatosAmpliacionesNet]: state => {
    return state.datosAmpliacionesNet;
  }
};
const mutations = {
  [types.mutations.SetAmpliacion]: (state, obj) => {
    state.datosAmpliaciones = obj;
  },
  [types.mutations.SettipoSolicitudLis]: (state, objList) => {

    state.tipoSolicitudLis = objList;
  },
  [types.mutations.SetdatosAmpliacionesNet]: (state, datosAmpliacionesNet) => {
    state.datosAmpliacionesNet = datosAmpliacionesNet;
  }
};
const actions = {
  [types.actions.RegistrarAmpliacion]: ({ commit }, pObj) => {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.post(`pajel/ampliacion/add`, pObj).then(r => {
        let obj = {};
        if (r.status === 200) {
          obj = r.data.resultado;
          obj.fechaInicioAmpliacion = Vue.prototype.$fechas.FormatearYYYYMMDDTHHmmssZ_to_DDMMYYYY(
            obj.fechaInicioAmpliacion
          );
          obj.fechaFinAmpliacion = Vue.prototype.$fechas.FormatearYYYYMMDDTHHmmssZ_to_DDMMYYYY(
            obj.fechaFinAmpliacion
          );
        }

        commit(types.mutations.SetAmpliacion, obj);
        resolve(r);
      });
    });
  },
  [types.actions.ModificarAmpliacion]: ({ commit }, pObj) => {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http
        .put(`pajel/ampliacion/update/${pObj.ampliacionId}`, pObj)
        .then(r => {
          let obj = r.data.resultado;
          obj.fechaInicioAmpliacion = Vue.prototype.$fechas.FormatearYYYYMMDDTHHmmssZ_to_DDMMYYYY(
            obj.fechaInicioAmpliacion
          );
          obj.fechaFinAmpliacion = Vue.prototype.$fechas.FormatearYYYYMMDDTHHmmssZ_to_DDMMYYYY(
            obj.fechaFinAmpliacion
          );
          commit(types.mutations.SetAmpliacion, obj);
          resolve(r);
        });
    });
  },
  [types.actions.ObtenerAmpliacionNetPorPersonaId]: (
    { commit },
    pPersonaId
  ) => {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http
        .get(`pajel/ampliacion/net/ampliaciones/listPorPersonaId/${pPersonaId}`)
        .then(r => {
          commit(types.mutations.SetdatosAmpliacionesNet, r.data);
          resolve(r);
        });
    });
  },
  [types.actions.ObtenerAmpliacionModificacion]: ({ commit }, pObj) => {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.get(`pajel/ampliacion/list_ampliacion_modificacion/${pObj.pSolicitudId}/${pObj.pPromocionEmpresarialNetId}/${pObj.pTramiteId}/${pObj.pEstadoAmpliacionId}`)
        .then(r => {
          var itemLst = [];

          if (r.data.length > 0) {
            r.data.forEach(function (itemProm) {
              itemProm.fechaInicioAmpliacion = Vue.prototype.$fechas.FormatearYYYYMMDDTHHmmssZ_to_DDMMYYYY(
                itemProm.fechaInicioAmpliacion
              );
              itemProm.fechaFinAmpliacion = Vue.prototype.$fechas.FormatearYYYYMMDDTHHmmssZ_to_DDMMYYYY(
                itemProm.fechaFinAmpliacion
              );
              itemLst.push(itemProm);
            });
          } else {
            itemLst.push({});
          }

          var objTipoSolicitudLis = [];

          if (r.data.length > 0) {
            if (r.data[0].tipoAmpliacionModificacionId === 1700)
              objTipoSolicitudLis.push(1700);
            if (r.data[0].tipoAmpliacionModificacionId === 1701)
              objTipoSolicitudLis.push(1701);
            if (r.data[0].tipoAmpliacionModificacionId === 1702) {
              objTipoSolicitudLis.push(1700);
              objTipoSolicitudLis.push(1701);
            }
          }

          commit(types.mutations.SettipoSolicitudLis, objTipoSolicitudLis);
          let objAmpliacionModificaicon = itemLst[0];
          objAmpliacionModificaicon.tipoPrioridadId = pObj.pTipoPrioridadId // carga tipo prioridad ampliacion/modificaiocn
          commit(types.mutations.SetAmpliacion, objAmpliacionModificaicon);
          resolve(r);
        });
    });
  },
  [types.actions.ObtenerAmpliacion]: ({ commit }, pObj) => {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http
        .get(
          `pajel/ampliacion/list/${pObj.pSolicitudId}/${pObj.pPromocionEmpresarialNetId
          }/${pObj.pTramiteId}/${pObj.pTipoAmpliacionModificacionId}/${pObj.pEstadoAmpliacionId
          }`
        )
        .then(r => {
          var itemLst = [];

          if (r.data.length > 0) {
            r.data.forEach(function (itemProm) {
              itemProm.fechaInicioAmpliacion = Vue.prototype.$fechas.FormatearYYYYMMDDTHHmmssZ_to_DDMMYYYY(
                itemProm.fechaInicioAmpliacion
              );
              itemProm.fechaFinAmpliacion = Vue.prototype.$fechas.FormatearYYYYMMDDTHHmmssZ_to_DDMMYYYY(
                itemProm.fechaFinAmpliacion
              );
              itemLst.push(itemProm);
            });
          } else {
            itemLst.push({});
          }

          var objTipoSolicitudLis = [];

          if (r.data.length > 0) {
            if (r.data[0].tipoAmpliacionModificacionId === 1700)
              objTipoSolicitudLis.push(1700);
            if (r.data[0].tipoAmpliacionModificacionId === 1701)
              objTipoSolicitudLis.push(1701);
            if (r.data[0].tipoAmpliacionModificacionId === 1702) {
              objTipoSolicitudLis.push(1700);
              objTipoSolicitudLis.push(1701);
            }
          }

          commit(types.mutations.SettipoSolicitudLis, objTipoSolicitudLis);
          commit(types.mutations.SetAmpliacion, itemLst[0]);
          resolve(r);
        });
    });
  },
  [types.actions.EnviarSolicitud]: ({ commit }, pObj) => {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http
        .post(`pajel/ampliacion/net/ampliacion/enviar_solicitud?prioridad_alta=${pObj.prioridadAlta}&ha_cambiado_representante_legal=${pObj.haCambiadoRepresentanteLegal}`, pObj.obj)
        .then(r => {
          resolve(r);
        });
    });
  },
  [types.actions.ObtieneAmpliacionesNet]: (
    { commit },
    pPromocionEmpresarialNetId
  ) => {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http
        .get(
          `pajel/ampliacion/net/ampliaciones/list/${pPromocionEmpresarialNetId}`
        )
        .then(r => {
          commit(types.mutations.SetdatosAmpliacionesNet, r.data);
          resolve(r);
        });
    });
  },
  [types.actions.ObtieneAmpliacionxAmpliacionId]: (
    { commit },
    pAmpliacionId
  ) => {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http
        .get(`pajel/ampliacion/find/${pAmpliacionId}`)
        .then(r => {
          resolve(r);
        });
    });
  },
  [types.actions.ObtieneAmpliacionObservadoxTramiteId]: ({ commit }, pTramiteId ) => {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.get(`pajel/ampliacion/observado/find/${pTramiteId}`) .then(r => {
          resolve(r);
        });
    });
  }
};
export default {
  state,
  actions,
  getters,
  mutations
};
